
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.94 37.18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Laag_2","data-name":"Laag 2"}},[_c('g',{attrs:{"id":"Laag_1-2","data-name":"Laag 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M23 24.78a.48.48 0 00-.71 0 .57.57 0 000 .77l1.09 1.27H20.6a3.21 3.21 0 01-3.1-3.29v-3.21h6.65a.49.49 0 00.5-.48v-7.15a4 4 0 00-3.95-4.12.48.48 0 00-.41.2 4.22 4.22 0 01-.88.91 4 4 0 01-5.72-.91.48.48 0 00-.41-.2 4 4 0 00-3.94 4.1v7.08a.49.49 0 00.47.51h6.67v8.16a3.17 3.17 0 01-3.12 3.23H10.6l1.1-1.24a.54.54 0 000-.74.49.49 0 00-.71 0l-1.91 2.18a.55.55 0 000 .72L11 34.71a.48.48 0 00.71 0 .56.56 0 000-.76l-1.1-1.27h2.74a4.1 4.1 0 003.12-1.46v4.18l-1.2-1.15a.48.48 0 00-.71 0 .55.55 0 000 .75l2 2a.48.48 0 00.68 0l2-2a.54.54 0 000-.75.48.48 0 00-.7 0l-1.19 1.15v-9.12a4 4 0 003.13 1.57h2.74l-1.1 1.23a.54.54 0 000 .74.52.52 0 00.35.14.48.48 0 00.37-.17l1.88-2.15a.55.55 0 000-.72z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M17 0a4.45 4.45 0 014.34 4.56A4.45 4.45 0 0117 9.12a4.45 4.45 0 01-4.34-4.56A4.45 4.45 0 0117 0m13.88 6.58a.56.56 0 010 .75.49.49 0 01-.72 0l-.87-.91-.86.91a.49.49 0 01-.72 0 .54.54 0 010-.75l.87-.91-.87-.92a.54.54 0 010-.75.49.49 0 01.72 0l.86.91.87-.91a.49.49 0 01.72 0 .56.56 0 010 .75l-.88.92zM29.26.75a4.8 4.8 0 00-4.67 4.92 4.68 4.68 0 109.35 0A4.81 4.81 0 0029.26.75M7 4.75l-2.6 2.6a.49.49 0 01-.71 0L2.31 5.86a.57.57 0 010-.76.49.49 0 01.71 0H3l1 1.11L6.33 4A.48.48 0 017 4a.54.54 0 010 .75zm-2.32-4A4.8 4.8 0 000 5.67a4.8 4.8 0 004.68 4.91 4.8 4.8 0 004.67-4.91A4.8 4.8 0 004.68.75"}})])])])
          )
        }
      }
    